export const ELEMENTS_FOR_CONTAINER_HEIGHT: Record<
  string,
  Partial<{
    configPropKey: string;
    configPropValue: string;
    viewport: string;
  }>
> = {
  NFTsGrid: {},
  Explore: {},
  CollectionsRanking: {
    configPropKey: 'rankingLayout',
    configPropValue: 'all',
    viewport: 'desktop'
  }
};
